import(/* webpackMode: "eager" */ "/var/www/apect/src/app/status/page.tsx");
